var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9952 1.06582C20.2623 0.735255 21.5 1.69148 21.5 3.00105V15.2067V15.2068C21.5 17.4159 19.7091 19.2068 17.5 19.2068C15.2909 19.2068 13.5 17.4159 13.5 15.2068C13.5 12.9976 15.2909 11.2068 17.5 11.2068C18.2286 11.2068 18.9117 11.4016 19.5 11.7419V7.50096L10 9.97922V17.7067H9.96904C9.98948 17.8705 10 18.0374 10 18.2068C10 20.4159 8.20914 22.2068 6 22.2068C3.79086 22.2068 2 20.4159 2 18.2068C2 15.9976 3.79086 14.2068 6 14.2068C6.72857 14.2068 7.41165 14.4016 8 14.7419V5.47932C8 4.56918 8.6145 3.77382 9.49516 3.54408L18.9952 1.06582ZM10 7.91229L19.5 5.43403V3.00105L10 5.47932V7.91229ZM17.5 13.2068C18.6045 13.2068 19.5 14.1022 19.5 15.2067V15.2068C19.5 16.3114 18.6046 17.2068 17.5 17.2068C16.3954 17.2068 15.5 16.3114 15.5 15.2068C15.5 14.1022 16.3954 13.2068 17.5 13.2068ZM8 18.2068C8 19.3114 7.10457 20.2068 6 20.2068C4.89543 20.2068 4 19.3114 4 18.2068C4 17.1022 4.89543 16.2068 6 16.2068C7.10457 16.2068 8 17.1022 8 18.2068Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.64d0204787c4c08ed4150a43881d4f61.svg";
export { ForwardRef as ReactComponent };